import { Collapse } from "antd";
import React from "react";
import { formatDescription } from "../../../core/SearchResult/SearchResult";
import SearchResults from "../../../core/SearchResults";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { Button, FormLabel, Row } from "react-bootstrap";
import { labels } from "../../../../localization/labels";

const { Panel } = Collapse;

const downloadIcon = (document, onDownload) => {
  const url = document?._links?.download?.href;
  if (url) {
    return (
      <Button
        variant="link"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          onDownload(url);
        }}
      >
        <FontAwesomeIcon icon={faFileDownload} />
      </Button>
    );
  } else {
    return null;
  }
};

const documentHeader = (document, onDownload) => {
  return (
    <span>
      {downloadIcon(document, onDownload)}
      {document?.title}
    </span>
  );
};

const documentResults = (result, onDownload) => {
  return (
    result?.documents?.length > 0 && (
      <>
        <Row>
          <FormLabel className="Label search-result-description">
            {labels.documents}:
          </FormLabel>
        </Row>
        <Collapse bordered={false} className="ghost-collapse">
          {result.documents.map(
            document =>
              document?.id && (
                <Panel
                  className="ghost-collapse"
                  header={documentHeader(document, onDownload)}
                  key={document.id}
                >
                  <p className="withoutBottomMargin search-result-description">
                    {formatDescription(document?.description)}
                  </p>
                </Panel>
              )
          )}
        </Collapse>
      </>
    )
  );
};

const KnowledgeManagementSearch = props => {
  return (
    <div className="container">
      <div className="containerShadow">
        <SearchResults
          searchResults={props.data}
          onOpen={props.onOpen}
          openInNewTab={props.openInNewTab}
          pageInfo={props.pageInfo}
          onPageNumberClick={props.onPageNumberClick}
          additionalContent={result =>
            documentResults(result, props.onDownloadClick)
          }
        />
      </div>
    </div>
  );
};

export default KnowledgeManagementSearch;
